import React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { makeStyles } from "@material-ui/core";

// import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  margin: {
    marginRight: 70,
    [theme.breakpoints.down("sm")]: {
      marginRight: 3,
    },
  },
}));

function NavNotLoggedIn() {
  const classes = useStyles();

  // const { t, i18n } = useTranslation();

  // const handleClick = (lang) => {
  //   console.log("click detecte");
  //   i18n.changeLanguage(lang);
  // };

  return (
    <Box sx={{ flexGrow: 1, marginBottom: 3 }}>
      <AppBar position="static">
        <Toolbar
          sx={{
            justifyContent: "space-between",
            bgcolor: "#006EFF",
            height: "73px",
            width: "100%",
          }}
        >
          <Box
            ml={3}
            sx={{ height: 30 }}
            component="img"
            alt="logo"
            src="/carlo_logo_image.png"
          />
          <Box
            className={classes.margin}
            sx={{ display: "flex", flexDirection: "row" }}
          >
            {/* <Button color="inherit" onClick={() => handleClick("fr")}>
              FR
            </Button>
            <Typography variant="h4" component="div">
              |
            </Typography>
            <Button color="inherit" onClick={() => handleClick("es")}>
              ES
            </Button> */}
            <Button href="/" color="inherit">
              SE CONNECTER
            </Button>
            <Typography variant="h4" component="div">
              |
            </Typography>
            <Button href="/inscription" color="inherit">
              S'INSCRIRE
            </Button>
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
}

export default NavNotLoggedIn;
